import React, { Component, Fragment } from "react";
import "./CustomHeroCard.css";
import CustomHeroCardButtonCol from "./CustomHeroCardButtonCol";
import CustomHeroCardButtonRow from "./CustomHeroCardButtonRow";
import ReactHtmlParser from "react-html-parser";
var md = require("markdown-it")({
  html: true,
  linkify: true,
  typographer: true,
});
var mila = require("markdown-it-link-attributes");
md.use(mila, [
  {
    matcher(href, config) {
      return href.startsWith("https://chatapps");
    },
    attrs: {
      rel: "noopener",
      class: "internal-link",
    },
  },
  {
    matcher(href, config) {
      return !href.startsWith("https://chatapps");
    },
    attrs: {
      target: "_blank",
      rel: "noopener",
      class: "external-link",
    },
  },
]);
const ADDLINK_URL = process.env.REACT_APP_API_URL + "/links";
const RECORD_RECOMMENDER = process.env.REACT_APP_API_URL + "/recommender-stats";
export default class CustomSignInCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showmore: false,
    };
    this.action = this.action.bind(this);
  }

  openImage(url) {
    if (window.parent) {
      window.parent.postMessage(`openUrl:${url}`, "*");
    } else {
      window.location = url;
    }
  }

  action(button) {
    console.log("window.parent:", window.parent);
    console.log("button value:", button.value);
    if (window.parent) {
      window.parent.postMessage(`openUrl:${button.value}`, "*");
    } else {
      window.location = button.value;
    }
  }

  render() {
    const herocard = this.props.herocard;
    // console.log(
    //   "this.props.cardActivitiesSummary",
    //   this.props.cardActivitiesSummary
    // );
    //console.log(herocard);
    //image link
    let imageLink = "https://bmbuiassetsprod.blob.core.windows.net";

    if (this.props.imagedomain) {
      imageLink = this.props.imagedomain;
    }
    // console.log(997, imageLink);
    let imageUrl;
    if (herocard.images && herocard.images.length > 0) {
      imageUrl = herocard.images[0].url;
    }

    let webConfig = herocard.webConfig ?? {};

    let feedback_response = JSON.parse(
      localStorage.getItem(this.props.iid + "-chatfeedback")
    );
    let feedbackbody;
    if (feedback_response !== null) {
      feedbackbody = feedback_response.filter(
        (i) => i.messageId === this.props.messageId
      )[0];
    }
    return (
      <div
        className="herocard-container"
        data-activity-id={this.props.messageId}
        data-con-id={this.props.conversationId}
        data-feedback={feedbackbody !== undefined && feedbackbody.feedback}
        data-view-btn={this.props.replyToId}
        data-msg-type={this.props.cardActivitiesSummary}
        data-inzendesk={this.props.inZenDesk}
      >
        {imageUrl ? (
          <Fragment>
            <img className="herocard-image" src={imageUrl} alt="" />
            {this.props.cardActivitiesSummary !== "Welcome" &&
              this.props.cardActivitiesSummary !== "Fallback" && (
                <a className="view">
                  <img
                    className="open-link-img"
                    onClick={() => {
                      this.openImage(imageUrl);
                    }}
                    src={`${imageLink}/images/OpenLinkIcon.png`}
                    alt=""
                  />
                </a>
              )}
          </Fragment>
        ) : (
          ""
        )}
        {herocard.title || herocard.text ? (
          <div className="herocard-text-area">
            {herocard.title ? (
              <div className={`ac-textBlock herocard-title-text`}>
                {herocard.title}
              </div>
            ) : (
              ""
            )}
            {herocard.text ? (
              <div className="ac-textBlock">
                {herocard.text.split("\n").map(function (item, key) {
                  return (
                    <span key={key}>
                      {ReactHtmlParser(md.renderInline(item))}
                      <br />
                    </span>
                  );
                })}
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        {herocard.buttons && webConfig.actionsRow ? (
          <div className="herocard-button-row-container">
            {herocard.buttons.map((btn) => (
              <CustomHeroCardButtonRow
                btn={btn}
                botSettings={this.props.botSettings}
                action={this.action}
              />
            ))}
          </div>
        ) : (
          ""
        )}
        {herocard.buttons && !webConfig.actionsRow ? (
          <div className="herocard-button-col-container">
            {herocard.buttons.map((btn, index) => (
              <CustomHeroCardButtonCol
                key={index}
                btn={btn}
                botSettings={this.props.botSettings}
                action={this.action}
              />
            ))}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
